// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__aUQFc","modalBox":"Modal_modalBox__lM7TX","closeButton":"Modal_closeButton__mmbbl","title":"Modal_title____nhr","content":"Modal_content__FbG0o"};